
import { Mapper } from "../../../../../core/base";
import { DistributionArea } from "planning-portal-library/src/lib/core/domain";
import { DistributionAreaWebEntity } from "./distribution-area-web-entity";

export class DistributionAreaWebRepositoryMapper extends Mapper<DistributionAreaWebEntity, DistributionArea> {
  mapFrom(param: DistributionAreaWebEntity): DistributionArea {
    return {
      id: param.id,
      name:param.name
    };
  }

  mapTo(param: DistributionArea): DistributionAreaWebEntity {
    return {
        id: param.id,
        name:param.name
    };
  }
}
